import ColorPicker from "../picker/ColorPicker";

export default function CommonStyleEditor({ cell, onChange }) {

    const cell_type = cell.type;

    return(
        <div className="property-section">
            <div className="property-section-title">Styles communs</div>
            <div className="property-row">
                <div className="property-label">Couleur de fond</div>
                <ColorPicker value={cell.styles_properties?.background_color || '#ffffff'} onChange={(color) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, background_color: color}, type: cell_type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Opacité</div>
                <input className="property-input property-input-small" min="0" max="1" step="0.1" type="number" value={cell.styles_properties?.opacity ?? 1} onChange={(e) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, opacity: parseFloat(e.target.value)}, type: cell_type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Border radius</div>
                <input className="property-input property-input-small" type="number" value={cell.styles_properties?.border_radius || 0} onChange={(e) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, border_radius: parseInt(e.target.value)}, type: cell_type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Border color</div>
                <ColorPicker value={cell.styles_properties?.border_color || '#000000'} onChange={(color) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, border_color: color}, type: cell_type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Border width</div>
                <input className="property-input property-input-small" type="number" value={cell.styles_properties?.border_width || 0} onChange={(e) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, border_width: parseInt(e.target.value)}, type: cell_type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Border style</div>
                <select className="property-input property-input-small" value={cell.styles_properties?.border_style || 'solid'} onChange={(e) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, border_style: e.target.value}, type: cell_type})}>
                    <option value="solid">Solid</option>
                    <option value="dashed">Dashed</option>
                    <option value="dotted">Dotted</option>
                    <option value="double">Double</option>
                    <option value="groove">Groove</option>
                    <option value="ridge">Ridge</option>
                    <option value="inset">Inset</option>
                    <option value="outset">Outset</option>
                </select>
            </div>
            <div className="property-row">
                <div className="property-label">Padding</div>
                <input className="property-input property-input-small" type="number" value={cell.styles_properties?.padding || 0} onChange={(e) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, padding: parseInt(e.target.value)}, type: cell_type})}/>
            </div>
        </div>
    )
}